export enum QuoteStage {
  Initial = 'INITIAL',
  BaseQuote = 'BASEQUOTE',
  Plans = 'PLANS',
  Options = 'OPTIONS',
  Declarations = 'DECLARATIONS',
  PolicyHolders = 'POLICYHOLDERS',
  Details = 'DETAILS',
  Payment = 'PAYMENT',
}

export enum QuoteRoute {
  Empty = '',
  Home = '/',
  Quote = 'quote',
  Plans = 'plans',
  Options = 'options',
  Details = 'details',
  Payment = 'payment',
  Confirmation = 'confirmation',
  AMT = 'annual-travel-insurance',
}
